export enum SubscriptionsServiceType {
    NEWSLETTER = 'newsletter',
    BACKTOSTORE = 'backInStore',
}
